import './index.scss'
import {h} from 'preact';
import {BaseAnnotation} from '../base_annotation';
import {disabledOverride, accessibleAnnotation} from 'utilities/accessibility';
import {COMPOSITION_TYPES, getCompositionInfo} from 'constants/annotations';
import { expandable } from 'rendering/behaviors/expandable';
import { ControlBar } from 'rendering/components/adjacent_control_bar';


const BUTTON_TOOL_TYPES = ['quizBack', 'quizNext', 'quizSubmit', 'quizConfirmation'];

export class PopAnnotation extends BaseAnnotation {
    constructor(...args) {
        super(...args);
        this.renderCount = 0;
    }

    render () {
        const { showExpanded = false } = this.options;

        if (!this.shouldRender) {
            return null;
        }

        const disabledAttrs = this.props.classes?.includes('disabled') ? disabledOverride : {};
        
        const rootAttrs = {
            ref: ref => this.el = ref,
            style: this.getElementStyles(),
            ...this.dataAttrs,
            ...this.applyActions(this.actions),
            ...(BUTTON_TOOL_TYPES.includes(this.props.toolType) && accessibleAnnotation),
            ...disabledAttrs //overrides tab index applied in line above if button is disabled. 
        }

        return (
            <div {...rootAttrs } className={ this.classes }>
                 { showExpanded && (<ControlBar onExpand={ this.onExpandPlayerAnnotation } onCollapse={ this.onCollapsePlayerAnnotation } styles={ this.controlBarStyles }/>)}
                <div style={this.innerStyle}>
                    <div style={this.innerStyle}>{this.fitText ? this.fitTextSvg : this.contents}</div>
                </div>
            </div>
        );
    }

    componentDidMount(...args) {
        super.componentDidMount(...args);
        this.forceUpdate(); // ensure el is available to calculate text viewbox
    }

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate && super.componentDidUpdate(prevProps, prevState);

        if (prevProps.content !== this.props.content) {
            this.renderCount = 0;
        }
    }

    get innerStyle () {
        if (this.fitText) {
            return {
                height: '100%' // this allows the outline to cover the entire visible annotation
            }
        }
    }

    get fitText () {
        return this.options.fitTextToContainer || false;
    }

    get fitTextSvg () {
        const styles = super.getElementStyles();
        const { content } = this.props;
        const { color, fontFamily } = styles;

        if (this.el && this.renderCount < 2) { // need to render at least once to get initial values for text bounding box
            try {
                const { x, y, width, height } = this.el.querySelector('svg text').getBBox();
                this.viewbox = `${x} ${y} ${width} ${height}`;
                this.renderCount++;
            } catch (e) {
                console.warn('error getting fitted text bounding box', e);
            }
        }

        return (
            <svg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' viewBox={ this.viewbox } style='width: 100%; height: 100%'>
                <text
                    x='50%'
                    y='50%'
                    fill={ color || 'white' }
                    font-family={ fontFamily || '"Noto Sans", sans-serif' }>
                    {
                        content
                    }
                </text>
            </svg>
        );
    }

    getElementStyles (...args) {
        let styles = super.getElementStyles(...args);

        if (this.options.backgroundColor) {
            styles = {
                backgroundColor: this.options.backgroundColor,
                ...styles
            }
        }

        if (this.options.localized) {
            // localized annotations should always be behind other annotations
            // they are spatially part of the video plane
            styles.zIndex = '-1';
        }

        return styles;
    }

    get legacyClasses () {
        const base = [
            'popcorn-pop',
            'active',
            (this.options.transitionClass || ''),
            (this.options.mode ? `hapyak-theme-${this.options.mode} popcorn-pop-${this.options.mode}` : '')
        ];

        return base.join(' ');
    }

    get shouldRender() {
        if (this.options.localized && this.contents === '') {
            return false;
        }

        return true;
    }

    get dataAttrs() {
        const attrs = super.dataAttrs;

        attrs['aria-label'] = this.contents;
        attrs['title'] = this.contents;

        return attrs;
    }

    static get composition () {
        return getCompositionInfo('POP');
    }

    static get schemaType () {
        return 'pop';
    }
}
